var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m8.99175069 3.65291667h2.00824931v-3.498c-.3464711-.04766667-1.5380385-.15491667-2.92575619-.15491667-2.8955087 0-4.87901008 1.82141667-4.87901008 5.16908333v3.08091667h-3.19523373v3.9105h3.19523373v9.8395h3.91750687v-9.8385833h3.0659945l.4867094-3.91050003h-3.55362049v-2.69408334c.00091659-1.13025.30522457-1.90391666 1.87992668-1.90391666z"}));
}

FacebookIcon.defaultProps = {"height":"22","viewBox":"0 0 11 22","width":"11"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
